//
//
//
//
//
//
//
//
//

import { PlusSquareIcon } from 'vue-feather-icons'
import TaskDetailsItem from '@/components/tasks/TaskDetailsItem'

// noinspection JSUnusedGlobalSymbols
export default {
  name: 'TaskDetailsStatus',
  components: {
    TaskDetailsItem,
    PlusSquareIcon
  },
  props: {
    task: {
      type: Object,
      required: true
    }
  },
  computed: {
    status () {
      const mapping = {
        0: this.$t('tasks.details.status_0'),
        1: this.$t('tasks.details.status_1'),
        2: this.$t('tasks.details.status_2'),
        3: this.$t('tasks.details.status_3'),
        9: this.$t('tasks.details.status_9')
      }

      return mapping[this.task.status]
    }
  }
}
